if (!customElements.get("nss-carousels")) {
    customElements.define("nss-carousels", class NSSCarousels extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                slidesContainer: ".js-nss-carousel-slides",
                slides: ".js-nss-carousel-slide",
                dotsContainer: ".js-nss-carousel-navigation",
                nextButton: ".js-nss-carousel-next-button",
                previousButton: ".js-nss-carousel-previous-button"
            };

            this.slidesContainer = this.querySelector(this.selectors.slidesContainer);
            this.slides = document.querySelectorAll(this.selectors.slides);
            this.dotsContainer = this.querySelector(this.selectors.dotsContainer);
            this.nextButton = this.querySelector(this.selectors.nextButton);
            this.previousButton = this.querySelector(this.selectors.previousButton);
            if (this.slidesContainer != null) {
                this.init();
            }
        }

        chageArrows() {
            this.querySelectorAll('.flickity-button').forEach(function (item) {
                item.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="11" height="19"> <path fill="none" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-miterlimit="10" transform="translate(1.06073 1.06071)" d="M0 0L8.4723454 8.333333" fill-rule="evenodd"/> <path fill="none" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-miterlimit="10" transform="matrix(1 0 0 -1 1.06073 17.7274)" d="M0 0L8.4723454 8.333333" fill-rule="evenodd"/> </svg>';
            })
        }

        init() {
            /**
             Initialize Flickity with the recommended configuration options
             */
            this.carousel = new Flickity(this.slidesContainer, {
                prevNextButtons: true,
                groupCells: true,
                cellAlign: 'center',
                pageDots: true,
                watchCSS: true,
                wrapAround: true,
                on: {
                    ready: () => {
                        this.chageArrows();
                    }
                }

            });

        }
    });
}